<script setup>
import { ensureRef } from '@/common/util'
import ManApikey from '@/components/admin/service/ManApikey.vue'
import ManInqueries from '@/components/admin/service/ManInqueries.vue'
import ManNotice from '@/components/admin/service/ManNotice.vue'
import ManPrivacyConsent from '@/components/admin/service/ManPrivacyConsent.vue'
import ManTermsOfSite from '@/components/admin/service/ManTermsOfSite.vue'
import AdmLayout from '@/pages/layout/AdmLayout.vue'
import { useMetaStore } from '@/stores'
import _ from 'lodash-es'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
const submenus=ref(['oneonone_inquery','roadview_inquery','applytousetheopenapi','announcements','termsofuse','privacyconsent_required','privacyconsent_optional','locationterms','privacypolicy'])
,route=useRoute(),admLayout=ref(null),inited=ref(false),metaStore=useMetaStore()
function init(){
  if(metaStore.dispmode=='minimum'){
      _.remove(submenus.value,item=>item=='roadview_inquery')
      _.remove(submenus.value,item=>item=='applytousetheopenapi')
      _.remove(submenus.value,item=>item=='termsofuse')
      _.remove(submenus.value,item=>item=='privacyconsent_required')
      _.remove(submenus.value,item=>item=='privacyconsent_optional')
      _.remove(submenus.value,item=>item=='locationterms')
      _.remove(submenus.value,item=>item=='privacypolicy')
  }
  inited.value=true
}
init()
</script>
<template>
  <AdmLayout v-if="inited" ref="admLayout" menutk="manserv" :submenus="submenus">
    <v-tabs-window-item v-for="sm in submenus" :value="sm" class="overflow-y-auto">
      <ManInqueries v-if="sm=='oneonone_inquery'||sm=='roadview_inquery'" :category="sm"/>
      <ManApikey v-if="sm=='applytousetheopenapi'"/>
      <ManNotice v-if="sm=='announcements'"/>
      <ManPrivacyConsent v-if="sm.startsWith('privacyconsent')" :wkey="sm"/>
      <ManTermsOfSite v-if="sm=='termsofuse'" :termstype="sm"/>
      <ManTermsOfSite v-if="sm=='privacypolicy'" :termstype="sm"/>
      <ManTermsOfSite v-if="sm=='locationterms'" :termstype="sm"/>
    </v-tabs-window-item>
  </AdmLayout>
</template>
